import React, {useEffect, useState} from 'react'
import {CustomAlert} from '../../atoms'
import ActionDialog from '../action-dialog'
import {patchEvaluationProfile} from '../../../api/index';
import {useMutation} from "@tanstack/react-query";
import i18n from '../../../assets/i18n'
import {manageQueriesWithPrefix} from "../../../api/mutations/mutationCallbacks";
import {ALERT_LEVEL, QUERY_ACTIONS, QUERY_KEYS} from "../../../config/constants";
import {useAppContext} from "../../../context/appContext";

const ModalDisableEvaluationProfile = ({ open, handleClose, evaluationData, showAlert, alert, setAlert }) => {
  const {createAlert} = useAppContext();
  const [evaluationDataState, setEvaluationDataState] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [modalConfirmButtonTitle, setModalConfirmButtonTitle] = useState("");

  useEffect(() => {
    if (open) {
      setEvaluationDataState(evaluationData);

      if (evaluationData) {
        setModalTitle(i18n.ia_evaluation[evaluationData.is_active ? 'confirmDeactivation' : 'confirmActivation'].replace('{name}', `${evaluationData.name || ''}`));
        if (evaluationData.id) {
          setModalConfirmButtonTitle(i18n.ia_evaluation[evaluationData.is_active ? 'buttonConfirmDisable' : 'buttonConfirmEnable']);
        }
      }
    }
  }, [open, evaluationData]);

  // Se cierra tras la respuesta y el aviso de éxito sale fuera del modal; si falla, el modal sigue abierto con el error
  const changeEvaluationProfile = async ({id, data}) => {
    try {
      await patchEvaluationProfile(id, data);
      manageQueriesWithPrefix([QUERY_KEYS.IA_EVALUATION], QUERY_ACTIONS.REFETCH);
      handleClose();
      createAlert(evaluationDataState.is_active
        ? i18n.ia_evaluation.evaluationDisabledSuccessfully
        : i18n.ia_evaluation.evaluationEnabledSuccessfully, ALERT_LEVEL.SUCCESS);
    } catch (error) {
      setAlert({
        message: evaluationDataState.is_active
          ? i18n.ia_evaluation.evaluationDisabledError
          : i18n.ia_evaluation.evaluationEnabledError,
        severity: 'error',
      });
      console.error("Error updating data:", error);
    }
  };

  const mutationChangeEvaluationProfile = useMutation(changeEvaluationProfile);

  const handleClickDisable = async (e) => {
    e.preventDefault();

    try {
      if (evaluationDataState && evaluationDataState.id) {
        await mutationChangeEvaluationProfile.mutateAsync(
          {
            id: evaluationData.id,
            data: {is_active: !evaluationDataState.is_active},
          });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleModalClose = () => {
    setEvaluationDataState(null);
    handleClose();
  };

  return (
    <ActionDialog
      open={open}
      title={modalTitle}
      onClose={handleModalClose}
      onConfirm={handleClickDisable}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={modalConfirmButtonTitle}
      confirmColor={evaluationDataState && evaluationDataState.is_active ? 'error' : 'default'}
      isPending={mutationChangeEvaluationProfile.isLoading}
    >
      {showAlert && <CustomAlert severity={alert.severity} message={alert.message} />}
    </ActionDialog>
  )
}

export default ModalDisableEvaluationProfile